import * as React from 'react';
import * as styles from './Notification.css';
export function Notification(_ref) {
  var description = _ref.description,
    button = _ref.button,
    onMouseMove = _ref.onMouseMove;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container'],
    onMouseMove: onMouseMove
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['message']
  }, description), button);
}